"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=void 0;var _raphael=_interopRequireDefault(require("../vendors/redraphael/source/raphael.svg"));var _default={extension:function extension(FusionCharts){(0,_raphael.default)(FusionCharts.getDep("redraphael","plugin"))},name:"redraphaelSvg",type:"plugin",requiresFusionCharts:true};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/core/src/_internal/redraphael/redraphael.svg.js
// module id = Dpv5
// module chunks = 5